export default "__VITE_ASSET__f104d053__"